import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface SiteAdProps {
  className?: string;
}

export const SiteAd = ({ className = "" }: SiteAdProps) => {
  const { data: settings } = useQuery({
    queryKey: ["site_ad"],
    queryFn: async () => {
      const { data } = await supabase
        .from("site_settings")
        .select("setting_value")
        .eq("setting_key", "site_ad")
        .single();
      return (data?.setting_value as any) ?? { enabled: false, image_url: "" };
    },
  });

  const enabled = settings?.enabled ?? false;
  const imageUrl = settings?.image_url || "";

  if (!enabled || !imageUrl) return null;

  return (
    <div className={`rounded-lg overflow-hidden ${className}`}>
      <img
        src={imageUrl}
        alt="إعلان الموقع"
        className="w-full h-auto object-contain"
        loading="lazy"
      />
    </div>
  );
};
